// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1406":"01ee46b06b91cb40","2888":"2c0f0b12e6b51764","5272":"07bc7768b295737c","7215":"ad1a7d40c566def4"}[chunkId] + ".css";
};